import React, { useState } from 'react';
import OtpInput from './Otp';
import { StyledSignUp } from './Otp/Otp.styles';
import Toast from '../Toast';
import Button from '../Button';
import authService from '../../services/authService';
import OnboardingTemplate from '../OnboardingTemplate';
import { FormContent } from '../Login/Login.styles';
import { useNavigate } from 'react-router-dom';
const OtpConfirm = ({ setOtpConfirmation }) => {
  const resetEmail = localStorage.getItem('otp_email');
  const [otpValue, setOtpValue] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function handelResend() {
    try {
      const resp = await authService.sendOtp({ email: resetEmail });
      if (resp.message) {
        Toast({
          type: 'info',
          message: resp.message,
        });
      }
    } catch (error) {
      Toast({
        type: 'error',
        message: error.message,
      });
    }
  }
  async function handelVerifyEmail(e) {
    setLoading(true);
    const payload = {
      email: resetEmail,
      otp: otpValue,
    };
    try {
      const resp = await authService.verify(payload);
      if (resp.success) {
        Toast({
          type: 'success',
          message: resp.message,
        });
        setLoading(false);
        navigate('/change-password', { state: { from: 'reset' } });
      }
    } catch (error) {
      Toast({
        type: 'error',
        message: error.message,
      });
      setLoading(false);
    }
  }
  return (
    <OnboardingTemplate>
      <FormContent>
        <StyledSignUp>
          <div className="heading-text">
            <h1>Verify OTP!</h1>
            <p>
              We’ve sent an 4-digit otp to your mail <br />
              <i>{resetEmail}</i>
            </p>
          </div>
          <OtpInput
            numInputs={4}
            inputBg={'transparent'}
            setOtpValue={value => setOtpValue(value.join(''))}
            handleResentOtp={() => handelResend()}
          />

          <Button width="100%" delayAnimation loader={loading} onClick={handelVerifyEmail}>
            Submit
          </Button>
        </StyledSignUp>
      </FormContent>
    </OnboardingTemplate>
  );
};

export default OtpConfirm;
